/**
 * 圖片 URL 處理工具
 * 確保圖片 URL 始終是完整的絕對路徑
 */

import { getApiBase } from '../api/apiUtils';

/**
 * 將圖片 URL 轉換為完整的絕對路徑
 * @param url 圖片 URL（可能是相對路徑或完整 URL）
 * @returns 完整的絕對路徑 URL
 */
export function normalizeImageUrl(
  url: string | null | undefined
): string | undefined {
  if (!url) {
    return undefined;
  }

  // 如果已經是完整的 URL（以 http:// 或 https:// 開頭），直接返回
  if (url.startsWith('http://') || url.startsWith('https://')) {
    return url;
  }

  // 如果是相對路徑（以 / 開頭），加上 API base URL
  if (url.startsWith('/')) {
    const apiBaseUrl = getApiBase();
    return `${apiBaseUrl}${url}`;
  }

  // 如果是以 assets/ 開頭的相對路徑，加上 API base URL 和前綴 /
  if (url.startsWith('assets/')) {
    const apiBaseUrl = getApiBase();
    return `${apiBaseUrl}/${url}`;
  }

  // 其他情況，假設是完整的 key，加上 API base URL 和前綴 /assets/
  const apiBaseUrl = getApiBase();
  return `${apiBaseUrl}/assets/${url}`;
}
